import { Card, CardBody } from 'reactstrap';
import { PeriodMetrics } from '../models/dashboardModels';
import { activeTab } from '../types/dashboard.types';
import { IconCalendarEvent } from '@tabler/icons-react';

interface Props {
  activeTab: activeTab;
  period: PeriodMetrics;
}

const MetricsDateDashboard = ({ activeTab, period }: Props) => {
  return (
    <Card className="mb-4 border-info dv2-period">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <IconCalendarEvent size={20} className="text-info me-3" />
            <div>
              <h4 className="mb-1 text-info">Rango de fecha</h4>
              <div className="d-flex align-items-center flex-wrap">
                <span className="text-dark font-weight-bold">
                  {period.start}
                </span>
                <span className="mx-2 text-muted">al</span>
                <span className="text-dark font-weight-bold">{period.end}</span>
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default MetricsDateDashboard;
